<div mat-dialog-container>
  <div mat-dialog-content>
    <div class="close-row">
      <a (click)="close()">
        <img
          class="close-icon"
          src="assets/images/shared/Icon - Close - Active.svg"
        />
      </a>
    </div>
    <div class="modal-title grey-color">Privacy Principles</div>

    <div class="privacy-principles-body legal-notes">
      <div class="std-fs-s std-fs-md-xs std-fw-normal text-justify">
        <h1>General</h1>
        <p>
          By accessing the “Allianz SAT” and using its contents, you acknowledge
          and agree that you have read and understood the following terms of use
          and you agree to be bound by them. Do not use or access the SAT if you
          do not agree with these terms of use.
        </p>
        <h1>Personal Data</h1>
        <p>
          In collecting and submitting personal data of customers or prospective
          customers in the Allianz SAT, you hereby agree to comply with the
          provisions of the Personal Data Protection Act 2010 and the relevant
          terms on processing of personal data as may be set out in your
          contracts with us, as the case may be, or as we may otherwise inform
          you, from time to time.
          <br /><br />
          In terms of your personal data which you may provide us via the
          Allianz SAT, the same shall be processed in compliance with the
          Personal Data Protection Act 2010 and in accordance with relevant
          terms on processing of personal data set out in the your contracts
          with us, as the case may be. For more information on our policy on
          data privacy, you may also refer to the Allianz Privacy Standard
          <span
            (click)="downloadFile()"
            (keydown.enter)="downloadFile()"
            tabindex="0"
            role="button"
            class="link"
            >here</span
          >.
        </p>

        <h1>Web Tracking</h1>
        <p>
          We may collect information about your visit to our site to assist us
          to measure and improve our website. Examples of information that we
          collect include: day and time of your visit, whether you have visited
          our website previously, whether you used a search engine to find us
          and some geographical information about what country and state you are
          in.
          <br /><br />
          The Allianz SAT uses Google Analytics, a web analytic service provided
          by Google, Inc. (“Google”) Analytics uses “cookies”, which are text
          files placed on your computer to help the website analyze how users
          use the site. The information generated by the cookie about your use
          of the website will be transmitted to and stored by Google on servers
          in the United States.
          <br /><br />
          The IP-anonymization is active on the Allianz SAT. Google will use
          this information on behalf of the operator of this website for the
          purpose of evaluating your use of this website, compiling reports on
          website activity for the website operators and providing them other
          services relating to website activity and internet usage. The
          IP-address that your Browser conveys within the scope of Google
          Analytics will not be associated with any other data held by Google.
          You may refuse the use of cookies by selecting the appropriate
          settings on your browser, however please note that if you do this you
          may not be able to use the full functionality of this website.
          <br /><br />

          We store the data generated by the Analytic Tools securely and do not
          share it with third parties except to our group of companies and our
          service providers where necessary for the following purposes:
        </p>
        <ul>
          <li>
            <p>for web hosting services for this website; and/or</p>
          </li>
          <li>
            <p>
              to gather non-personal information (using cookies) in order to
              evaluate the website’s effectiveness for online marketing
              activities and to measure statistical data.
            </p>
          </li>
        </ul>
        <p>
          We use cookies in order to provide you with a user-friendly, safe and
          effective website. By, default, the cookie settings on this website
          are set to “Allow all cookies”. If you continue, you consent to this.
          <br /><br />
          For information on disabling these cookies, please go to the privacy
          settings section within your browser. You can selectively disable the
          action of installing Google Analytics on your browser component of the
          opt-out provided by Google. To disable the action of Google Analytics,
          please refer to the link below:
          <br /><br />
          To opt out of being tracked by Google Analytics cookies you may go to
          <a href="https://tools.google.com/dlpage/gaoptout" target="_blank"
            >https://tools.google.com/dlpage/gaoptout</a
          >. <br /><br />
        </p>
        <h1>How are social media plug-ins used on the Allianz SAT?</h1>
        <br />
        <p>
          The Allianz SAT uses the following social media plug-ins ("plug-ins"):
        </p>
        <ul>
          <li>
            <p>
              Share on Facebook, powered by Facebook Inc., 1601 S. California
              Ave., Palo Alto, CA 94304, USA;
            </p>
          </li>
          <li>
            <p>
              Tweet button, powered by Twitter Inc., 795 Folsom St., Suite 600,
              San Francisco, CA 94107, USA;
            </p>
          </li>
        </ul>
        <p>
          All plug-ins are indicated with the brand names of the respective
          operators Facebook, Google, Twitter, whatsapp, Linkedin and Messenger
          ("Operator"). To increase the level of data protection and in
          accordance with applicable laws and regulations, we have implemented
          the additional programs by means of a so-called 2-click solution. This
          procedure ensures that when you access the Allianz SAT, no direct
          connection of your browser to the servers of the Operator is
          established. Only if you activate the plug-ins by clicking on them and
          thereby grant your consent to the data transfer, your browser
          establishes a direct connection to the server of the respective
          Operator. The content of the plug-ins is then transmitted by the
          Operators directly to your browser and integrated by them into the
          website.
          <br /><br />
          By accepting the plug-in, the Operator receives the information that
          your browser has accessed the Allianz SAT. If you logged in to your
          account when you visited the Allianz SAT, the Operator can connect
          your visit to your account directly. If you interact with the plug-in,
          e.g. by clicking on the Facebook button or the Tweet button, the data
          will be transferred directly from your browser to the Operator and
          saved by the Operator. In addition, the information will be published
          on the relevant social network or on your Twitter account and will be
          visible to your contacts. If you do not want this data transfer to the
          Operators, you must log out of your respective account before you
          click on the plug-ins and activate them.
          <br /><br />
          For more information on the purpose and scope of data collection,
          processing and use, please refer to the privacy statements below:
        </p>

        <ul class="std-ta-left">
          <li>
            <p>
              <a
                href="https://de-de.facebook.com/about/privacy/"
                target="_blank"
              >
                Facebook: https://de-de.facebook.com/about/privacy/
              </a>
            </p>
          </li>
          <li>
            <p>
              <a
                href="https://developers.google.com/+/web/policies"
                target="_blank"
              >
                Google: https://developers.google.com/+/web/policies
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://twitter.com/privacy" target="_blank">
                Twitter: https://twitter.com/privacy
              </a>
            </p>
          </li>
          <li>
            <p>
              <a
                href="https://www.whatsapp.com/legal/#privacy-policy"
                target="_blank"
              >
                Whatsapp: https://www.whatsapp.com/legal/#privacy-policy
              </a>
            </p>
          </li>
          <li>
            <p>
              <a
                href="https://www.linkedin.com/legal/privacy-policy"
                target="_blank"
              >
                Linkedin: https://www.linkedin.com/legal/privacy-policy
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://messenger.com/privacy" target="_blank">
                Messenger: https://messenger.com/privacy
              </a>
            </p>
          </li>
        </ul>

        <h1>Data Privacy Queries</h1>
        <p>
          In case you have any further questions about your data privacy at
          Allianz, please do not hesitate to contact us by emailing us at
          <a href="mailto:privacy@allianz.com.my">
            privacy&#64;allianz.com.my
          </a>

          <br />
          By logging in with your User ID and password, you acknowledge and
          agree to the terms above.
        </p>
      </div>
    </div>
  </div>
</div>
